import { Target, Eye, Lightbulb, Users } from "lucide-react";

const aims = [
  {
    icon: Target,
    title: "Bridge the Digital Skills Gap",
    desc: "Bringing ICT knowledge and opportunities to Oke-Ogun and surrounding rural communities.",
  },
  {
    icon: Lightbulb,
    title: "Inspire Responsible AI Adoption",
    desc: "Promoting ethical and responsible adoption of artificial intelligence and modern technologies.",
  },
  {
    icon: Users,
    title: "Empower Youth & Professionals",
    desc: "Equipping individuals and businesses with skills to compete on a global stage.",
  },
  {
    icon: Eye,
    title: "Foster Collaboration",
    desc: "Building bridges between technology stakeholders, educators, policymakers, and local ecosystems.",
  },
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Label */}
        <div className="mb-16">
          <span className="section-label">About Us</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white mt-4 max-w-3xl">
            Empowering rural communities through{" "}
            <span className="gradient-text">technology & innovation</span>
          </h2>
          <p className="text-zinc-400 text-base sm:text-lg mt-6 max-w-2xl leading-relaxed">
            Founded in 2018 and headquartered in Ibadan, Oyo State, The ICT Summit sensitizes and instills
            relevant ICT knowledge to people in rural areas, ensuring they fit into the present digital world
            and are prepared for employment opportunities and self-development.
          </p>
        </div>

        {/* Aims Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 stagger-children">
          {aims.map((aim) => (
            <div
              key={aim.title}
              className="bg-zinc-900 border border-zinc-800 p-8 group hover:border-teal-600/50 transition-all duration-300"
              data-testid={`aim-card-${aim.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="w-12 h-12 bg-teal-600/10 flex items-center justify-center mb-5 group-hover:bg-teal-600/20 transition-colors">
                <aim.icon size={24} className="text-teal-500" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 tracking-tight">{aim.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{aim.desc}</p>
            </div>
          ))}
        </div>

        {/* Mission Statement */}
        <div className="mt-16 bg-zinc-900/50 border border-zinc-800 p-8 md:p-12">
          <div className="flex items-start gap-4">
            <div className="w-1 h-full min-h-[60px] ai-glow flex-shrink-0 rounded-full" />
            <div>
              <span className="section-label">Our Mission</span>
              <p className="text-zinc-300 text-base sm:text-lg mt-3 leading-relaxed max-w-3xl">
                "To sensitize and instill relevant ICT knowledge to the people in rural areas to ensure
                they fit into the present digital world which prepares them for employment opportunities
                and self-development to eradicate unemployment in our dear society."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
